// src/components/AppRoutes/AppRoutes.js
import { Switch, Route } from "react-router-dom";
import LoginForm from "../LoginForm";
import RegisterForm from "../RegisterForm";
import ValidationOtp from "../ValidationOtp";
import Main from "../Main";

const AppRoutes = () => {
  return (
    <Switch>
      <Route exact path="/" component={Main} />
      <Route path="/login" component={LoginForm} />
      <Route path="/register" component={RegisterForm} />
      <Route path="/otp" component={ValidationOtp} />
    </Switch>
  );
};

export default AppRoutes;
